// Admin Token 管理 —— 優先從環境變數讀取，其次 localStorage
const STORAGE_KEY = 'promptforge-admin-token';

export function getAdminToken(): string {
  // 1. 環境變數（構建時注入）
  const envToken = import.meta.env.VITE_ADMIN_TOKEN as string | undefined;
  if (envToken && envToken.trim().length > 0) {
    return envToken.trim();
  }
  // 2. localStorage（用戶手動輸入）
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored && stored.trim().length > 0) {
      return stored.trim();
    }
  } catch {
    // localStorage 不可用（無痕模式等）
  }
  return '';
}

export function setAdminToken(token: string): void {
  try {
    if (token.trim()) {
      localStorage.setItem(STORAGE_KEY, token.trim());
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // 無痕模式等無法寫入
  }
}

export function hasAdminToken(): boolean {
  return getAdminToken().length > 0;
}
